import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { StorySection } from '../components/sales/StorySection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { CTASection } from '../components/sales/CTASection';
import { trackAddToCart } from '../utils/pixel';
export function SalesPage() {
  const [showStickyBar, setShowStickyBar] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://eficienciadigital.ca/';
  };
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--color-cream)',
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-88">
      {/* Nav bar */}
      <nav className="sticky top-0 z-40 px-6 py-4 flex items-center justify-between" style={{
      backgroundColor: 'rgba(253, 246, 238, 0.92)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(196, 98, 45, 0.1)'
    }} data-id="element-89">
        <div className="flex items-center gap-2" data-id="element-90">
          <span className="text-lg" data-id="element-91">🌸</span>
          <span className="font-serif font-bold text-lg" style={{
          color: 'var(--color-text-dark)'
        }} data-id="element-92">
            Mamá Sin Culpa
          </span>
        </div>
        <button className="font-sans font-semibold text-sm px-5 py-2 rounded-full transition-all duration-200 hover:scale-105 flex items-center gap-2" style={{
        backgroundColor: 'var(--color-terracotta)',
        color: '#fff'
      }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--color-terracotta-dark)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'var(--color-terracotta)'} onClick={() => document.getElementById('cta-section')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-93">
          <span className="line-through opacity-60 text-xs" data-id="element-94">$19.99</span>
          <span data-id="element-95">Obtener Guía — $6.39</span>
        </button>
      </nav>

      {/* Page sections */}
      <HeroSection data-id="element-96" />
      <StorySection data-id="element-97" />
      <SolutionSection data-id="element-98" />
      <CTASection data-id="element-99" />

      {/* Footer */}
      <footer className="py-10 px-6" style={{
      backgroundColor: 'var(--color-text-dark)'
    }} data-id="element-100">
        <div className="max-w-3xl mx-auto text-center" data-id="element-101">
          <p className="font-serif font-bold text-base mb-1" style={{
          color: 'rgba(255,255,255,0.9)'
        }} data-id="element-102">
            🌸 Mamá Sin Culpa
          </p>
          <p className="font-sans text-xs mb-6" style={{
          color: 'rgba(255,255,255,0.35)'
        }} data-id="element-103">
            Este producto es una guía digital en formato PDF. Los resultados
            pueden variar.
          </p>

          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-104">
            <div className="h-px w-12 opacity-20" style={{
            backgroundColor: 'var(--color-terracotta)'
          }} data-id="element-105" />
            <span className="opacity-20" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-106">
              ✦
            </span>
            <div className="h-px w-12 opacity-20" style={{
            backgroundColor: 'var(--color-terracotta)'
          }} data-id="element-107" />
          </div>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-108">
            <a href="#" className="font-sans text-xs transition-opacity duration-200 hover:opacity-100" style={{
            color: 'rgba(255,255,255,0.45)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.9)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'} data-id="element-109">
              Términos y Condiciones
            </a>
            <span style={{
            color: 'rgba(255,255,255,0.2)'
          }} data-id="element-110">
              ·
            </span>
            <a href="#" className="font-sans text-xs transition-opacity duration-200" style={{
            color: 'rgba(255,255,255,0.45)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.9)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'} data-id="element-111">
              Política de Privacidad
            </a>
          </div>

          <p className="font-sans text-xs" style={{
          color: 'rgba(255,255,255,0.2)'
        }} data-id="element-112">
            © {new Date().getFullYear()} Mamá Sin Culpa · Todos los derechos
            reservados
          </p>
        </div>
      </footer>

      {/* Sticky bottom bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 transition-all duration-500" style={{
      transform: showStickyBar ? 'translateY(0)' : 'translateY(100%)',
      opacity: showStickyBar ? 1 : 0
    }} data-id="element-113">
        <div className="flex items-center justify-between px-6 py-4 gap-4" style={{
        backgroundColor: 'var(--color-terracotta)',
        boxShadow: '0 -4px 24px rgba(196, 98, 45, 0.3)'
      }} data-id="element-114">
          <div className="flex-1 min-w-0" data-id="element-115">
            <p className="font-serif font-bold text-white text-sm sm:text-base truncate" data-id="element-116">
              MAMÁ SIN CULPA
            </p>
            <p className="font-sans text-white text-xs opacity-80" data-id="element-117">
              Solo $6.39 · Descarga inmediata
            </p>
          </div>
          <button onClick={handleBuyClick} className="flex-shrink-0 font-sans font-bold text-sm sm:text-base px-6 py-3 rounded-full transition-all duration-200 hover:scale-105 active:scale-95 whitespace-nowrap" style={{
          backgroundColor: '#fff',
          color: 'var(--color-terracotta)'
        }} data-id="element-118">
            QUIERO MI GUÍA →
          </button>
        </div>
      </div>
    </div>;
}